import { render, staticRenderFns } from "./CardPayment.vue?vue&type=template&id=17666b48"
import script from "./CardPayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardPayment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/payment/card-payment.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports